var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import rangerSprite from '@assets/images/ranger-attack.png';
import { CARTRIDGE_TYPE } from '@models/CartridgeType';
import { CELL_GAP, CELL_SIZE } from '@static/game';
import { FONT_FAMILY, SIZES } from '@static/styles';
import { createFontStyle } from '@utils/createFontStyle';
import { ComponentWithPosition } from '@components/abstract/ComponentWithPosition';
import { CartridgeFactory } from '@components/cartridges/CartridgeFactory';
var RangerDefender = /** @class */ (function (_super) {
    __extends(RangerDefender, _super);
    function RangerDefender(x, y) {
        var _this = _super.call(this, x, y, CELL_SIZE - CELL_GAP * 2) || this;
        _this._health = 100;
        _this._timer = 0;
        _this._defenderSprite = new Image();
        _this._defenderSprite.src = rangerSprite;
        _this._frameX = 0;
        _this._frameY = 0; // Sprite is horizontal, therefore y always is 0
        _this._minFrame = 0;
        _this._maxFrame = 9; // Sprite consists of 10 pictures
        return _this;
    }
    RangerDefender.prototype.draw = function () {
        var imageWidth = 32;
        var imageHeight = 32;
        this._gameConfigurator.context.drawImage(this._defenderSprite, this._frameX * imageWidth, this._frameY, imageWidth, imageHeight, this._x, this._y, this._width, this._height);
        this._gameConfigurator.context.fillStyle = 'gold';
        this._gameConfigurator.context.textAlign = 'start';
        this._gameConfigurator.context.textBaseline = 'middle';
        this._gameConfigurator.context.font = createFontStyle(SIZES.characterHealthSize, FONT_FAMILY);
        this._gameConfigurator.context.fillText(Math.floor(this._health).toString(), this._x + CELL_SIZE / 3, this.y - CELL_GAP);
    };
    RangerDefender.prototype.shoot = function (cartridges) {
        this._timer++;
        this._frameX += 0;
        if (this._timer % 100 === 0) {
            cartridges.push(CartridgeFactory.createCartridge(CARTRIDGE_TYPE.ARROW, this._x + CELL_SIZE, this._y + CELL_SIZE / 2));
        }
        // Slow down animation 10 times
        if (this._gameConfigurator.frame % 10 !== 0)
            return;
        if (this._frameX < this._maxFrame) {
            this._frameX++;
        }
        else {
            this._frameX = 0;
        }
    };
    Object.defineProperty(RangerDefender.prototype, "health", {
        get: function () {
            return this._health;
        },
        set: function (health) {
            this._health = health;
        },
        enumerable: false,
        configurable: true
    });
    return RangerDefender;
}(ComponentWithPosition));
export { RangerDefender };
